import { PopupBlockedError } from 'utils/openLiveChat'

export interface CmsOpenLiveChatEventDetail {
  asPopup: boolean,
  /**
   * @param error If set, an error occurred in calling the function and it failed
   */
  callback?: (error?: unknown | PopupBlockedError) => void
}

export interface WithCmsErrorHandler {
  errorHandler?: (e: unknown) => void
}

/**
 * @param error If set, an error occurred in calling the function and it failed
 */
export interface ErrorWithCmsErrorHandler {
  detail: {
    callback?: (error?: unknown) => void
  }
}

/*
 * We want to check the interface, not class, since our api is using objects from separate packages
 * Javascript will detect them as different even though they aren't
 */
export const isCmsOpenLiveChatEvent = (obj: any | CmsOpenLiveChatEvent): obj is CmsOpenLiveChatEvent => (
  typeof obj === 'object' &&
  typeof obj.detail === 'object' &&
  typeof obj.detail.asPopup === 'boolean' &&
  (
    typeof obj.detail.callback === 'undefined' ||
    typeof obj.detail.callback === 'function'
  )
)

export const isErrorWithCmsErrorHandler = (obj: any | ErrorWithCmsErrorHandler): obj is ErrorWithCmsErrorHandler => (
  typeof obj === 'object' &&
  typeof obj.detail === 'object' &&
  (
    typeof obj.detail.callback === 'undefined' ||
    typeof obj.detail.callback === 'function'
  )
)

export class CmsOpenLiveChatEvent extends CustomEvent<CmsOpenLiveChatEventDetail> {
  constructor (asPopup: boolean, callback?: (e?: unknown) => void) {
    super('cms-open-live-chat', {
      detail: {
        asPopup,
        callback
      }
    })
  }
}

export class CmsOpenLiveChatIncorrectFieldsError extends Error {
  constructor (eventName: string, eventObject: any) {
    super(`Incorrect fields passed in ${eventName} event, unable to open live chat`)
  }
}
